module.exports = __webpack_public_path__ + "img/swiper-2.702e2737.png";